
<template v-cloak >
  <el-container>
    <el-aside width="-">
      <leftMenu from="detail"></leftMenu>
    </el-aside>
    <el-container>
      <el-header class="nav_header">
        &nbsp;&nbsp;&nbsp;
        <el-link @click="goBack" :underline="false">
          <span class="backBtn"></span></el-link>
        <h4>&nbsp;&nbsp;&nbsp;&nbsp;AI写作功能栏</h4> &nbsp;&nbsp;&nbsp;
        <div style="flex: 1;">
          <el-button v-if="carForm.carId" :class="changeTypeClass[0]" @click="changeType(0)"><i
              class="iconfont_yx">&#xe617;</i>文案库</el-button>
          <el-button v-if="carForm.carId" :class="changeTypeClass[4]" @click="changeType(4)"><i
              class="iconfont_yx">&#xe615;</i>图片库</el-button>
          <el-button v-if="articleInfo.articleType && articleInfo.articleType.indexOf('fin') === 0"
            :class="changeTypeClass[1]" @click="changeType(1)"><i class="iconfont_yx">&#xe618;</i>模块库</el-button>
          <el-button :class="changeTypeClass[2]" @click="changeType(2)"><i class="iconfont_yx">&#xe614;</i>文章库</el-button>
          <el-button v-if="articleInfo.articleType && articleInfo.articleType.indexOf('normal.template') === -1"
            :class="changeTypeClass[3]" @click="changeType(3)"><i class="iconfont_yx">&#xe616;</i>素材库</el-button>

          <!-- <el-button :class="changeTypeClass[5]" @click="changeType(5)">知识库</el-button> -->
        </div>
        <!-- <a href="javascript:void(0)">
          <div class="active_small"
               @click="toBuy">
          </div>
        </a> -->

        <el-button class="saveBtn" @click="saveArticle(false)"><i class="saveIcon"></i>&nbsp;保存</el-button>
        <div
          style="width: 20px;height: 0px;opacity: 1;transform: rotate(90deg);border: 1px solid rgba(238, 238, 238, 1);display: flex;">
        </div>
        <el-dropdown @command="handCommand">
          <div class="moreBtn"></div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="export">导出文章</el-dropdown-item>
            <el-dropdown-item command="help">帮助</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </el-header>
      <el-main class="main_workspace">

        <div class="changeType isActive">
          <carTab v-if="curTabIndex === 0" :articleId="articleId" :articleInfo="articleInfo" :carId="carForm.carId"
            @insert="insertDescToArticle" />

          <modelTab v-if="curTabIndex === 1" @insert="insertDescToArticle" :code="articleInfo.reqParams" />

          <articleTab :key="articleTabkKey" v-if="curTabIndex === 2" :articleId="articleId" :articleInfo="articleInfo"
            :articleExtendTag="articleExtendTag" :searchKey="articleSearchKey" @dragEnd="dragEnd" @toReport="toReport"
            @insert="insertDescToArticle" :articleContentArray="articleContentArray"
            @appndContentToArray="appndContentToArray" @closeDialog="closeIntelligenceEditDialog"
            @modifyArticleContent="modifyArticleContent" @modifyArticleContentArray="modifyArticleContentArray" />

          <materialTab v-if="curTabIndex === 3" :articleInfo="articleInfo" @insertHtml="insertHtml"
            @insert="insertDescToArticle" />

          <imageTab v-if="curTabIndex === 4" :carId="carForm.carId" :articleInfo="articleInfo" @insertHtml="insertHtml" />

          <knowlegeTab v-if="curTabIndex === 5" :articleInfo="articleInfo" :articleId="articleId"
            :searchKey="tempKnowlegeSearchKey" @dragEnd="dragEnd" :articleContentArray="articleContentArray"
            @appndContentToArray="appndContentToArray" @closeDialog="closeIntelligenceEditDialog"
            @modifyArticleContent="modifyArticleContent" @modifyArticleContentArray="modifyArticleContentArray" />
          <div v-if="intelligenceEditDialogVisible" class=" innerDialog">
            <div>
              <div class="t_r">
                <div style="clear: both;height: 9px;"></div>
                <el-link :underline="false" class="f_r" @click="closeAllDialog(true)"><i
                    class="iconfont">&#xe69f;</i>&nbsp;</el-link>
                <div style="clear: both"></div>
              </div>
              <el-row class="t_l">
                <el-col :span="22" style="height:calc(92vh - 180px)" class="likeWordContainer" :offset="1">
                  <el-form label-position="top">
                    <el-form-item label="近义词替换">
                      选中右侧内容，查找可替换词语
                    </el-form-item>
                    <el-form-item label="原文词汇">
                      <el-radio-group v-model="likeWordKeyWord" size="small" @change="chooseLikeWord"
                        style="line-height: 35px;">
                        <el-radio-button v-for="(v, k) in likeWordMap" :key="k" :label="k"></el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="替换词汇">
                      <el-radio-group v-model="newLikeWordKeyWord" size="small" @change="toReplaceLikeWord"
                        style="line-height: 35px;">
                        <template v-for="(v, k) in likeWordMap">
                          <template v-if="k === likeWordKeyWord">
                            <el-radio-button v-for="key in v" :key="key" :label="key"></el-radio-button>
                          </template>
                        </template>
                      </el-radio-group>
                    </el-form-item>
                  </el-form>

                  <el-row>

                    <el-form label-position="top">
                      <el-form-item label="全文替换">
                        <el-input v-model="sourceKeyword" placeholder="查找"></el-input>
                      </el-form-item>
                      <el-form-item label="">
                        <el-input v-model="targetKeyword" placeholder="替换"></el-input>
                      </el-form-item>

                      <el-col :span="24" class="t_c">
                        <br>
                        <el-button type="primary" @click="markSourceWord()">查找</el-button>
                        <el-button type="primary" @click="replaceAllLikeWord">全部替换</el-button>

                      </el-col>
                    </el-form>
                  </el-row>
                </el-col>
              </el-row>
            </div>

          </div>

          <div class="innerDialog" v-if="correctWordDialogVisible">
            <el-form label-position="top">
              <el-col :span="23" style="padding-left: 10px;">
                <el-form-item label="文本纠错">
                  <div style="font-size: 12px;font-weight: 400;color: rgba(139, 139, 167, 1);">
                    文本纠错将找出文章中可能存在的错误表达方式。
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <div style="clear: both;height: 9px;"></div>
                <el-link :underline="false" class="f_r" @click="closeAllDialog(true)"><i
                    class="iconfont">&#xe69f;</i>&nbsp;</el-link>
              </el-col>
            </el-form>
            <div style="clear: both;"></div>
            <template v-if="correctWordRes">

              <div class="totalRes">
                <template v-if="correctWordRes && correctWordRes.length > 0">

                </template>
                <template v-else>
                  <div>没有检测出相关结果</div>
                </template>
              </div>

              <el-table v-if="correctWordRes && correctWordRes.length > 0" :data="correctWordRes" width="80%" slot="empty"
                empty-text="检测通过" row-class-name="noBorder" header-row-class-name="noBorder tableHead">
                <el-table-column label="错误文本" width="100">
                  <template slot-scope="scope">
                    <span style="color:red">{{ scope.row.error }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="建议方案">
                  <template slot-scope="scope">
                    <span style="color:green">{{ scope.row.right }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <br><br><br><br><br>
            </template>
            <el-button type="primary" @click="checkCorrectWord">
              <template v-if="correctWordRes">
                重新检测
              </template>
              <template v-else>
                开始检测
              </template>
            </el-button>
            <div style="clear: both;"></div>
          </div>

          <div class="innerDialog" v-show="sensitiveWordDialogVisible">
            <div class="sensitiveContainer">

              <el-form label-position="top">
                <el-col :span="23" style="padding-left: 10px;">
                  <el-form-item label="敏感词检测">
                    <div style="font-size: 12px;font-weight: 400;color: rgba(139, 139, 167, 1);">
                      敏感词检测将找出文章中可能存在的敏感表达。
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <div style="clear: both;height: 9px;"></div>
                  <el-link :underline="false" class="f_r" @click="closeAllDialog(true)"><i
                      class="iconfont">&#xe69f;</i>&nbsp;</el-link>
                </el-col>
              </el-form>
              <div style="clear: both;"></div>
              <div class="totalRes">
                <template v-if="sensitiveWordRes.wordObj && sensitiveWordRes.wordObj.length === 0">
                  <div>没有检测出相关结果</div>
                </template>

              </div>

              <el-table v-if="sensitiveWordRes.wordObj && sensitiveWordRes.wordObj.length > 0"
                :data="sensitiveWordRes.wordObj" row-class-name="noBorder" header-row-class-name="noBorder tableHead">
                <el-table-column prop="keyword" label="敏感词" width="100">
                </el-table-column>
                <el-table-column prop="classifyName" label="原因">
                </el-table-column>
              </el-table>
              <div style="clear: both;"></div> <br><br><br><br><br>
              <el-button @click="checkSensitiveWord" style="width: 76.26px;color: white;
height: 36.26px;
opacity: 1;
border-radius: 9.6px;
background: rgba(42, 130, 228, 1);
justify-content: flex-start;
align-items: flex-start;
padding: 9.63px 9.63px 9.63px 9.63px;">
                <template v-if="sensitiveWordRes.totalStatus">
                  重新检测
                </template>
                <template v-else>
                  开始检测
                </template>
              </el-button>
            </div>
          </div>

          <div class="innerDialog" v-if="eventChartDialogVisible">
            <el-form label-position="top">
              <el-col :span="23" style="padding-left: 10px;">
                <el-form-item label="实体图谱">
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <div style="clear: both;height: 9px;"></div>
                <el-link :underline="false" class="f_r" @click="closeAllDialog(true)"><i
                    class="iconfont">&#xe69f;</i>&nbsp;</el-link>
              </el-col>
            </el-form>
            <div style="clear: both;"></div>
            <div class="scrollContainer" style="overflow-y: scroll;height: calc(100vh - 200px); margin-top: 15px;">
              <el-row class="newsDetailDialogTitle">
                <el-form label-position="top">

                  <el-col :span="24" style="padding-left: 10px;">
                    <el-form-item label="事件词云">
                      <div class="eventCard">
                        <div id="wordsChart" class="chartContainer"></div>
                      </div>
                    </el-form-item>
                  </el-col>

                  <el-col :span="24" style="padding-left: 10px;">
                    <el-form-item label="词性分类">
                      <div class="eventCard">
                        <div id="wordTypeChart" class="chartContainer"></div>
                      </div>
                    </el-form-item>
                  </el-col>

                  <el-col :span="24" style="padding-left: 10px;">
                    <el-form-item label="实体识别">
                      <div class="eventCard">
                        <div id="entityChart" class="chartContainer"></div>
                      </div>
                    </el-form-item>
                  </el-col>

                  <el-col :span="24" style="padding-left: 10px;">
                    <el-form-item label="词相关性">
                      <div class="eventCard">
                        <div id="wordsChart_panel" class="chartContainer"></div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-row>
            </div>
          </div>
        </div>

        <div class="my_edit_container">
          <div class="innerContainer" v-loading="articleLoading" element-loading-text="文章加载中">
            <div class="editContainer scrollContainer">
              <img src="../assets/imgs/recommend-article.png" v-show="showRecommend" class="recommend" alt="" />
              <div
                :class="'articleTitleContainer ' + ((articleInfo.articleType && articleInfo.articleType.indexOf('refer') > -1) ? 'isRefer' : (articleInfo.articleType && articleInfo.articleType.indexOf('upload') > -1) ? 'isUpload' : 'isAi')">
                <textarea ref="articleTitle" v-model="articleInfo.title" class="articleTitle" maxlength="50"></textarea>
              </div>

              <Editor v-if="editVisble" class="articleContent" id="articleContent" v-model="articleInfo.content"
                :init="editorInit">
              </Editor>

              <div class="rewriterBtn" v-if="((from !== 'articles') && articleInfo.totalChange)">
                <el-button type="primary" @click="toChangeArticle" :disabled="articleInfo.totalChange === 1">我想换一篇({{
                  articleInfo.nowChange + "/" +
                  articleInfo.totalChange }})</el-button>
              </div>
            </div>
            <p style="text-align: center;margin-top: 25px;color: #777;font-size: 0.8em;">字数：{{ wordcount }}</p>
          </div>
        </div>
      </el-main>
    </el-container>
    <el-dialog :visible.sync="rewriteDialogVisible" width="300px" style="text-align: left;" custom-class="rewriteDialog">
      <el-row>
        <el-col :span="2">
          <i class="iconfont_yx" style="color:#FFC300">&#xe61a;</i>
        </el-col>
        <el-col :span="22">
          <span style="color:#000000">请注意:换一换将直接覆盖当前初稿的内容，请谨慎操作</span><br><br>
          <el-checkbox v-model="hiddenRewiterTips"><span style="color:#999999">下次不再提示</span></el-checkbox>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rewriteDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeArticle">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="举报内容" :visible.sync="reportDialogVisible" width="400px" center
      custom-class="commonDialog reportDialog">
      <div style="margin-top: 10px;">举报文章为</div>
      <div style="display: flex;margin-top: 15px;">
        <div :class="reportInfo.myDocId ? 'isAi' : 'isRefer'">
        </div>
        <div style="margin-left: 10px;font-weight: 800;">{{ reportInfo.title }}</div>

      </div>
      <div style="clear: both;height: 20px;"></div>
      <div style="display: flex;">
        <div style="width:80px;flex-grow: 0;"></div>
        <el-radio-group v-model="reportInfo.tipOff" size="mini">
          <el-radio-button v-for="item in reportTypes" :key="item.id" :label="item.tipOff"
            class="report_type"></el-radio-button>
        </el-radio-group>
      </div>
      <br /><br />
      <div style="text-align: center;">
        <el-button type="primary" @click="doReport">提交</el-button>
      </div>

    </el-dialog>
  </el-container>
</template>

<script lang="js">
import leftMenu from '../components/left_menu.vue'
import Editor from '@tinymce/tinymce-vue'

import modelTab from '../components/article/modelTab.vue'
import draggable from 'vuedraggable'
import vEditDiv from '../components/v-edit-div'

import Loading from '../components/js/Loading.vue'
import LikeWord from '../components/article/likeWord.vue'
import articleTab from '../components/article/articleTab.vue'
import imageTab from '../components/article/imageTab.vue'
import materialTab from '../components/article/materialTab.vue'
import knowlegeTab from '../components/article/knowlegeTab.vue'
import carTab from '../components/article/carTab.vue'
import * as appJs from '../assets/js/app'

let echarts = require('echarts')
require('echarts-wordcloud')
require('echarts/lib/chart/graph')
export default {
  name: 'newsEdit',
  data: function () {
    return {
      reportDialogVisible: false,
      reportInfo: {
        tipOff: ''
      },
      reportTypes: [],
      articleTabkKey: 1,
      from: '',
      rewriteDialogVisible: false,
      hiddenRewiterTips: false,
      changeTypeClass: [
        'changeType ',
        'changeType ',
        'changeType ',
        'changeType ',
        'changeType ',
        'changeType '
      ],
      articleLoading: true,
      curTabIndex: -1,
      showRecommend: false,
      carForm: {
        carId: '',
        carDescType: '',
        subTitleType: '',
        tag: 'CARDESC',
        searchWord: '',
        page: 1,
        pageSize: 10
      },
      editVisble: true,
      tempKnowlegeSearchKey: '',
      bodyLoading: true,
      msnry: {},
      forderId: -1,

      // ckeditor  相关配置
      keywordCheckedList: [],
      title: '',
      sourceArticleTab: 'originArticle',

      wordcount: 0,

      editorInit: {
        resize: true,

        selector: '.articleContent',
        inline: false,
        language_url: 'static/tinymce/langs/zh-Hans.js',
        language: 'zh-Hans',
        init_instance_callback: function (editor) {
          editor.on('mouseup', function (editor) {
            let content = tinymce.activeEditor.selection.getContent()
            window.onEditorMouseUp(content)
          });
        },
        quickbars_insert_toolbar: false,
        // skin_url: 'static/tinymce/skins/ui/oxide-dark',
        file_picker_callback: (cb, value, meta) => {
          let _this = this
          var input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');
          input.onchange = function () {
            var file = this.files[0];
            let param = new FormData();
            param.append('file', file);
            _this.axios.post('/webApi/v3/clientUserImg/uploadImg', param).then(resp => {
              var reader = new FileReader();
              reader.onload = function () {
                cb(resp.data.url, { title: resp.data.name });
              };
              reader.readAsDataURL(file);
            });
          }
          input.click();
        },
        imagetools_fetch_image: function (img) { console.log(2) },
        // image_caption: true,
        automatic_uploads: true,
        file_picker_types: 'image',
        //  image_advtab: true, //图片高级样式  边框等
        menubar: false,
        content_css: './static/css/tiny.css',
        plugins: 'searchreplace autoresize  code table  autosave quickbars image charmap preview anchor  visualblocks  advlist autolink lists link image charmap preview anchor insertdatetime',
        toolbar: 'menuDateButton undo redo  removeformat  blocks  bold italic forecolor  backcolor  bullist numlist  alignleft aligncenter alignright  image ocrBtn table reportBtn',
        block_formats: '正文=p; 标题1=h2; 标题2=h3; 标题3=h4',

        setup: (editor) => {
          let _this = this
          editor.ui.registry.addIcon('icon_report', '<svg t="1704867294150" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3359" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20"><path d="M873.130667 85.333333c12.629333 0 22.869333 9.642667 22.869333 21.546667v588.8c0 15.616-8.533333 30.08-22.570667 38.357333l-336 197.76a50.517333 50.517333 0 0 1-50.858666 0l-336-197.76A44.672 44.672 0 0 1 128 695.68v-588.8c0-11.946667 10.24-21.546667 22.869333-21.546667h722.261334zM810.666667 170.666667H213.333333v501.290666l298.666667 175.786667 298.666667-175.829333V170.666667z" fill="#f39e1eed" p-id="3360"></path><path d="M458.666667 256h106.666666l-21.333333 298.666667h-64z" fill="#f39e1eed" p-id="3361"></path><path d="M512 652.8m-55.466667 0a55.466667 55.466667 0 1 0 110.933334 0 55.466667 55.466667 0 1 0-110.933334 0Z" fill="#f39e1eed" p-id="3362"></path></svg>')
          editor.ui.registry.addIcon('icon_ocr', '<svg t="1586832165522" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3091" width="20" height="20"><path d="M363.820455 429.221557c21.461078 21.461078 32.702595 54.163673 32.702595 91.976048 0 39.856287-11.241517 70.51497-32.702595 91.976048-21.461078 21.461078-50.075848 33.724551-84.822355 33.724551-35.768463 0-64.383234-11.241517-86.866268-33.724551-21.461078-21.461078-32.702595-52.11976-32.702594-91.976048 0-23.50499 4.087824-44.966068 11.241516-61.317365 5.10978-12.263473 12.263473-23.50499 21.461078-33.724551 9.197605-11.241517 19.417166-18.39521 32.702595-21.461078 14.307385-7.153693 32.702595-9.197605 52.119761-9.197605 35.768463-1.021956 64.383234 10.219561 86.866267 33.724551z m-47.00998 38.834331c-9.197605-11.241517-21.461078-16.351297-37.812375-16.351297s-28.61477 5.10978-37.812375 16.351297c-9.197605 11.241517-14.307385 28.61477-14.307386 52.119761s5.10978 40.878244 14.307386 52.11976c11.241517 11.241517 21.461078 16.351297 37.812375 16.351298s26.570858-5.10978 37.812375-16.351298 14.307385-28.61477 14.307385-54.163672c0-22.483034-5.10978-38.834331-14.307385-50.075849z m249.357285 79.712575c-4.087824 14.307385-9.197605 25.548902-16.351297 32.702595-7.153693 5.10978-16.351297 9.197605-25.548902 9.197605-14.307385 0-25.548902-5.10978-33.724551-14.307386-9.197605-11.241517-12.263473-28.61477-12.263473-56.207584 0-25.548902 5.10978-40.878244 14.307385-52.119761 9.197605-11.241517 19.417166-14.307385 33.724551-14.307385 11.241517 0 18.39521 2.043912 25.548902 9.197605 7.153693 5.10978 12.263473 14.307385 14.307385 23.50499l2.043913 9.197605 63.361277-14.307386-2.043912-9.197605c-5.10978-19.417166-14.307385-33.724551-25.548902-44.966067-19.417166-18.39521-42.922156-26.570858-73.580839-26.570859-33.724551 0-63.361277 11.241517-82.778443 33.724551-21.461078 23.50499-32.702595 54.163673-32.702595 94.01996 0 37.812375 11.241517 68.471058 32.702595 89.932136 21.461078 21.461078 49.053892 33.724551 80.734531 33.724551 26.570858 0 49.053892-7.153693 66.427146-19.417166 18.39521-12.263473 30.658683-32.702595 37.812375-59.273453l2.043912-9.197605-61.317365-19.417165-7.153693 4.087824z m144.095809 99.129741h-63.361278V394.47505h102.195609c25.548902 0 42.922156 2.043912 54.163673 7.153693 12.263473 5.10978 23.50499 14.307385 30.658682 26.570858 7.153693 12.263473 11.241517 25.548902 11.241517 40.878243 0 19.417166-5.10978 35.768463-16.351297 49.053893-7.153693 9.197605-18.39521 16.351297-28.61477 19.417165 4.087824 4.087824 7.153693 5.10978 9.197604 9.197605 7.153693 7.153693 16.351297 19.417166 26.570859 39.856287l33.724551 59.273454h-73.580839l-33.724551-56.207585c-11.241517-18.39521-18.39521-28.61477-23.50499-32.702595-4.087824-4.087824-5.10978-5.10978-11.241517-7.153693-2.043912 0-7.153693-2.043912-19.417165-2.043912l2.043912 99.129741zM778.734627 484.407186c2.043912-4.087824 4.087824-7.153693 4.087824-12.263473s-2.043912-11.241517-4.087824-14.307386c-4.087824-4.087824-7.153693-5.10978-11.241517-5.10978h-57.229541v40.878243h23.50499c26.570858 0 33.724551-2.043912 35.768463-2.043912 4.087824-2.043912 7.153693-3.065868 9.197605-7.153692z m0 0" fill="#262626" p-id="3092"></path><path d="M919.764567 909.540918c0 6.131737-4.087824 10.219561-10.219561 10.219561h-275.928144v102.195609h275.928144c62.339321 0 112.41517-50.075848 112.41517-112.41517v-275.928144h-102.195609v275.928144zM102.199697 112.41517c0-6.131737 4.087824-10.219561 10.21956-10.219561h275.928144v-102.195609h-275.928144c-62.339321 0-112.41517 50.075848-112.415169 112.41517v275.928143h102.195609v-275.928143zM909.545006 102.195609c6.131737 0 10.219561 4.087824 10.219561 10.219561v275.928143h102.195609v-275.928143c0-62.339321-50.075848-112.41517-112.41517-112.41517h-275.928144v102.195609h275.928144zM112.419257 919.760479c-6.131737 0-10.219561-4.087824-10.21956-10.219561v-275.928144h-102.195609v275.928144c0 62.339321 50.075848 112.41517 112.415169 112.41517h275.928144v-102.195609h-275.928144z" fill="#262626" p-id="3093"></path></svg>')
          editor.ui.registry.addIcon('icon_article_menu', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24" fill="none"><path id="路径 1" fill-rule="evenodd" style="fill:#2A82E4" opacity="1" d="M8.85795,9.94259v-5.18997h-5.18997v5.18997zM8.85795,3.02263v0c0.94999,0.01 1.71995,0.78 1.71995,1.72999v5.18997c0,0.96001 -0.76996,1.73001 -1.71995,1.73001h-5.18997c-0.96,0 -1.72999,-0.77 -1.72999,-1.73001v-5.18997c0,-0.94999 0.76999,-1.72999 1.72999,-1.72999zM8.85795,20.3125v-5.1899l-5.18997,0.01v5.1899zM8.85795,13.4026v0c0.94999,0 1.71995,0.77 1.71995,1.72v5.1999c0,0.95 -0.76996,1.72 -1.71995,1.72h-5.18997c-0.96,0 -1.72999,-0.77 -1.72999,-1.72v-5.1999c0,-0.95 0.76999,-1.72 1.72999,-1.72zM20.3079,7.34261l-3.68,-3.65998l-3.66,3.66998l3.67,3.66999zM21.5279,6.13261v0c0.67,0.67 0.67,1.75999 0,2.43999l-3.67,3.67c-0.68,0.67 -1.77,0.67 -2.44,0l-3.68,-3.67c-0.32,-0.33 -0.5,-0.77 -0.5,-1.22999c0,-0.45 0.18,-0.89 0.5,-1.21l3.68,-3.67998c0.67,-0.66999 1.76,-0.66999 2.44,0zM19.2279,20.3125v-5.1899l-5.19,0.01v5.1899zM19.2279,13.4026v0c0.96,0 1.73,0.77 1.73,1.72v5.1999c0,0.95 -0.77,1.72 -1.73,1.72h-5.19c-0.95,0 -1.72,-0.77 -1.73,-1.72v-5.1999c0,-0.95 0.78,-1.72 1.73,-1.72z"/></svg>')
          editor.ui.registry.addIcon('近义词替换', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" fill="none"><path id="路径 1" fill-rule="evenodd" style="fill:#000000" opacity="1" d="M4.19604,4.21191c-1.61,1.6 -1.86,4.12 -0.58999,6.00999c1.25999,1.88 3.68,2.62 5.77999,1.75c2.09996,-0.87 3.28996,-3.09999 2.83996,-5.32999c-0.44,-2.23 -2.39995,-3.83 -4.66995,-3.83c-1.26001,0 -2.47,0.5 -3.36001,1.4zM7.55605,1.21191c3.50995,0 6.35995,2.85 6.35995,6.36c0,3.50999 -2.85,6.35999 -6.35995,6.35999c-3.51001,0 -6.36001,-2.85 -6.36001,-6.35999c0,-3.51 2.85,-6.36 6.36001,-6.36z"/><path id="路径 2" fill-rule="evenodd" style="fill:#000000" opacity="1" d="M10.7897 11.1419C10.6697 11.4419 10.7397 11.7819 10.9597 12.0119L13.4797 14.5319C13.6297 14.6819 13.8397 14.7619 14.0497 14.7619C14.2597 14.7619 14.4597 14.6819 14.6097 14.5319C14.7597 14.3819 14.8497 14.1819 14.8497 13.9719C14.8497 13.7519 14.7597 13.5519 14.6097 13.4019L12.0897 10.8819C11.9397 10.7319 11.7397 10.6519 11.5297 10.6519C11.2097 10.6519 10.9097 10.8419 10.7897 11.1419Z"/><path id="路径 3" fill-rule="evenodd" style="fill:#3C90EE" opacity="1" d="M10.3071 6.32893L8.60707 4.62893C8.29707 4.31893 7.79707 4.31893 7.47707 4.62893C7.16707 4.94893 7.16707 5.44893 7.47707 5.75893L9.17707 7.45893C9.49707 7.76893 9.99707 7.76893 10.3071 7.45893C10.6171 7.14893 10.6171 6.63893 10.3071 6.32893Z"/></svg>')
          editor.ui.registry.addIcon('文本纠错', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" fill="none"><path id="路径 1" fill-rule="evenodd" style="fill:#000000" opacity="1" d="M4.33412,4.36805c-1.75,1.75 -2.01,4.49 -0.64,6.54995c1.37,2.05 4.01,2.85 6.29,1.9c2.28998,-0.94 3.58998,-3.36995 3.09998,-5.79995c-0.48,-2.42 -2.61,-4.17 -5.07998,-4.17c-1.38,0 -2.7,0.54 -3.67,1.52zM8.00412,1.24805c1.8,0 3.52998,0.71 4.79998,1.99c1.27,1.27 1.99,3 1.99,4.8c0,3.73995 -3.04,6.77995 -6.78998,6.77995c-3.74,0 -6.78,-3.04 -6.78,-6.77995c0,-3.75 3.03,-6.79 6.78,-6.79z"/><path id="路径 2" fill-rule="evenodd" style="fill:#3C90EE" opacity="1" d="M9.97711 8.84711L7.14711 6.01711C6.83711 5.70711 6.33711 5.70711 6.01711 6.01711C5.70711 6.33711 5.70711 6.83711 6.01711 7.14711L8.84711 9.97711C9.15711 10.2871 9.66711 10.2871 9.97711 9.97711C10.2871 9.66711 10.2871 9.15711 9.97711 8.84711Z"/><path id="路径 3" fill-rule="evenodd" style="fill:#3C90EE" opacity="1" d="M7.14711 9.97711L9.97711 7.14711C10.2871 6.83711 10.2871 6.33711 9.97711 6.01711C9.66711 5.70711 9.15711 5.70711 8.84711 6.01711L6.01711 8.84711C5.70711 9.15711 5.70711 9.66711 6.01711 9.97711C6.33711 10.2871 6.83711 10.2871 7.14711 9.97711Z"/></svg>')
          editor.ui.registry.addIcon('敏感词检测', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" fill="none"><path id="路径 1" fill-rule="evenodd" style="fill:#000000" opacity="1" d="M5.51211,4.56182c-0.74,0.22 -1.37,0.52 -1.95,0.92c-0.58,0.41 -1.55,1.27 -1.55,2.47c0,0.43 0.1,0.82 0.37,1.26c0.26,0.44 0.62,0.81998 1.18,1.21998c0.55,0.39 1.21,0.7 1.95,0.92c1.64,0.47 3.37,0.47 5.00999,0c0.74,-0.22 1.37,-0.52 1.95,-0.92c0.58,-0.41 1.55,-1.26998 1.55,-2.47998c0,-0.42 -0.11,-0.81 -0.37,-1.25c-0.26,-0.44 -0.62,-0.83 -1.18,-1.22c-0.56,-0.39 -1.21,-0.7 -1.95,-0.92c-0.81999,-0.24 -1.65999,-0.35 -2.50999,-0.35c-0.84,0 -1.69,0.11 -2.5,0.35zM8.01211,2.61182c4.19999,0 7.60999,2.39 7.60999,5.35c0,2.94998 -3.41,5.34998 -7.60999,5.34998c-4.2,0 -7.6,-2.4 -7.6,-5.34998c0,-2.95 3.4,-5.35 7.6,-5.35z"/><path id="路径 2" fill-rule="evenodd" style="fill:#3C90EE" opacity="1" d="M6.7958,8.03588c0,0.65 0.53,1.17 1.17,1.17c0.64,0 1.16,-0.52 1.16,-1.17c0,-0.64 -0.52,-1.16 -1.16,-1.16c-0.64,0 -1.17,0.52 -1.17,1.16zM7.9658,5.27588h-0.01c1.53,0 2.77,1.24 2.77,2.76c0,1.12 -0.68,2.13002 -1.71,2.56002c-1.03,0.43 -2.22,0.19 -3.01,-0.60002c-0.79,-0.79 -1.03,-1.98 -0.6,-3.02c0.43,-1.03 1.44,-1.7 2.56,-1.7z"/></svg>')
          editor.ui.registry.addIcon('实体图谱', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" fill="none"><path id="路径 1" fill-rule="evenodd" style="fill:#000000" opacity="1" d="M2.75991,3.64785v6.2c0,1.32005 1.08,2.40005 2.4,2.40005h8.11999v-6.20005c0,-1.32 -1.08,-2.4 -2.4,-2.4zM10.8799,2.04785c2.21,0 4,1.79 4,4v7.00005c0,0.44 -0.36,0.8 -0.8,0.8h-8.91999c-2.21,0 -4,-1.79 -4,-4.00005v-7c0,-0.44 0.36,-0.8 0.8,-0.8z"/><path id="路径 2" fill-rule="evenodd" style="fill:#3C90EE" opacity="1" d="M4.3999,8.79799c0,-0.44 0.36,-0.8 0.8,-0.8h2.4c0.44,0 0.8,0.36 0.8,0.8c0,0.44 -0.36,0.8 -0.8,0.8h-2.4c-0.44,0 -0.8,-0.36 -0.8,-0.8zM4.3999,5.98799c0,-0.44 0.36,-0.8 0.8,-0.8h4c0.44,0 0.8,0.36 0.8,0.8c0,0.44 -0.36,0.8 -0.8,0.8h-4c-0.44,0 -0.8,-0.36 -0.8,-0.8z"/></svg>')

          editor.ui.registry.addMenuButton('menuDateButton', {
            icon: 'icon_article_menu',
            onAction: (_) => editor.insertContent('<p>Its Friday!</p>'),
            fetch: function (callback) {
              let items = [
                {
                  type: 'menuitem',
                  icon: '近义词替换',
                  text: '近义词替换',
                  onAction: function (_) {
                    _this.openIntelligenceEditDialog()
                  }
                },
                {
                  type: 'menuitem',
                  icon: '文本纠错',
                  text: '文本纠错',
                  onAction: function (_) {
                    console.log('文本纠错')
                    _this.openCorrectWordDialog()
                  }
                },
                {
                  type: 'menuitem',
                  icon: '敏感词检测',
                  text: '敏感词检测',
                  onAction: function (_) {
                    console.log('敏感词检测')
                    _this.openSensitiveWordDialog()
                  }
                },
                {
                  type: 'menuitem',
                  icon: '实体图谱',
                  text: '实体图谱',
                  onAction: function (_) {
                    console.log('实体图谱')
                    _this.openEventChartDialog()
                  }
                }

              ];
              callback(items);
            }
          });

          editor.ui.registry.addButton('ocrBtn', {
            icon: 'icon_ocr',
            // text: 'OCR',
            onAction: function (api) {
              let input = document.createElement('input');
              input.setAttribute('type', 'file');
              input.setAttribute('accept', 'image/*');
              input.onchange = function () {
                let file = this.files[0];
                let param = new FormData();
                param.append('file', file);
                _this.axios.post('/webApi/v3/article/articleOcr', param).then(resp => {
                  let reader = new FileReader();
                  reader.onload = function () {
                    editor.insertContent('<span class="insertP">' + resp.data.content + '</span>')
                    api.setDisabled(false)
                  };
                  reader.readAsDataURL(file);
                });
              }
              input.click();
            },
            onSetup: function () {

            }
          });
          editor.ui.registry.addButton('reportBtn', {
            icon: 'icon_report',
            // text: 'OCR',
            onAction: function (api) {
              _this.toReport(_this.articleId, null, _this.articleInfo.title)
            },
            onSetup: function () {

            }
          });
        },
        quickbars_selection_toolbar: ''
      },

      editRange: null, // 选择的范围
      leftMaterialStatus: true,
      keyword: '',
      activeName: '文章库',
      articleId: '',
      articleInfo: {
        title: ''
      },

      articleContentArray: [],
      articleExtendTag: 'relate',

      articleSearchList: [], // 搜索文章
      articleSearchKey: '',

      searchMyKeyword: '',
      articleDetailDialogVisible: false,
      curNews: {}, // 当前打开的新闻
      curSentenceTypes: {}, // 当前新闻的扩展
      eventChartDialogVisible: false,
      sourceRepeatDialogVisible: false,
      intelligenceEditDialogVisible: false, // 智能编辑框
      searchContent: '',
      sourceNewsList: [],

      likeSentenceDialogVisible: false,

      leftMenu: 'initArticle',
      isModel: false,

      // 图片列表
      pageNo: 0,
      pageSize: 10,

      wCol: 2,

      isUpLoading: false,
      // 命题写作
      keyMap: {},
      // 我的文章
      articlePageNo: 0,
      articleKeyword: '',
      articleLoadingFinish: false,
      myArticles: [],
      count: 0,
      appendContent: '',

      // 敏感词
      sensitiveWordDialogVisible: false,
      sensitiveWordRes: {},

      // 词语纠错
      correctWordDialogVisible: false,
      correctWordRes: null,

      hasRight: false,

      curDialogType: '',
      dialogInnerContainerVisible: false,
      insertOrder: 0,
      likeWordMap: {},
      likeWordKeyWord: '',
      newLikeWordKeyWord: '',
      sourceKeyword: '',
      targetKeyword: '',
      vipInfo: {}

    }
  },
  metaInfo () {
    return {
      title: (this.articleInfo && this.articleInfo.title) || (this.articleInfo && this.articleInfo.themes) || '弈写AI辅助写作'
    }
  },
  methods: {
    toBuy () {
      let code = ''
      if (this.vipInfo.vipLevel === 'GOLD') {
        code = 3002
      }
      if (this.vipInfo.vipLevel === 'SLIVER') {
        code = 3003
      }
      console.log(code)
      this.$store.commit('showPriceDialog', code);
    },
    updateLikeWord () {
      for (let k in this.likeWordMap) {
        this.likeWordKeyWord = k
        break
      }
      this.chooseLikeWord()
    },
    seachLikeWord () { // 打开近义词
      console.log('搜索近义词')
      let _this = this
      if (!this.searchContent) {
        _this.likeWordMap = {}
        return
      }
      _this.axios.post('/webApi/v3/assist/similarWords', { 'sentence': this.searchContent, '$noLoading': true }).then((response) => {
        _this.likeWordMap = response.data.replaceMap
        _this.updateLikeWord()
      })
    },
    changeType (index) {
      this.closeAllDialog()
      this.curTabIndex = index
      this.changeTypeClass.forEach((item, index2) => {
        if (index === index2) {
          this.changeTypeClass[index2] = 'changeType isActive'
        } else {
          this.changeTypeClass[index2] = 'changeType'
        }
      })
      console.log(this.changeTypeClass)
      this.$forceUpdate()
    },
    goBack () {
      this.$router.back()
    },
    parseContent (content) {
      content = content.replace(/&hellip;/g, ' ');
      content = content.replace(/&amp;/g, '&');
      content = content.replace(/&lt;/g, '<');
      content = content.replace(/&gt;/g, '>');
      content = content.replace(/&nbsp;/g, ' ');
      content = content.replace(/&#39;/g, '\'');
      content = content.replace(/&quot;/g, '"');
      content = content.replace(/<br\/>/g, ' ');
      content = content.replace(/&rdquo;/g, '"');
      content = content.replace(/&ldquo;/g, '"');
      content = content.replace(/&middot;/g, ' ');
      content = content.replace(/<p>/g, ' ');
      content = content.replace(/<\/p>/g, ' ');
      return content
    },

    async load () {
      this.count += 2
    },
    appndContentToArray () { // 智能编辑   将句子插入文章列表
      this.articleContentArray.push(this.appendContent)
      this.appendContent = ''
      setTimeout(() => {
        var eles = document.getElementsByClassName('dragContainer2');
        for (var i = 0; i < eles.length; i++) {
          var temp = eles[i]
          temp.scrollTop = 10000
        }
      }, 100)
    },

    openIntelligenceEditDialog () { // 打开只能编辑
      this.closeAllDialog()
      appJs.checkVip().then(() => {
        this.intelligenceEditDialogVisible = true
      })
    },

    openSensitiveWordDialog () { // 敏感词检测
      this.closeAllDialog()
      appJs.checkVip().then(() => {
        this.sensitiveWordDialogVisible = true
      })
    },
    openCorrectWordDialog () { // 词语纠错
      this.closeAllDialog()
      appJs.checkVip().then(() => {
        this.correctWordDialogVisible = true
      })
    },

    closeAllDialog (needClear) {
      if (needClear) {
        tinymce.activeEditor.setContent(tinymce.activeEditor.getContent().replace(/redMark/g, ''))
        tinymce.activeEditor.setContent(tinymce.activeEditor.getContent().replace(/insertP/g, ''))
        tinymce.activeEditor.setContent(tinymce.activeEditor.getContent().replace(/sensitive_mark/g, ''))
      }

      this.correctWordDialogVisible = false
      this.sensitiveWordDialogVisible = false
      this.intelligenceEditDialogVisible = false
      this.eventChartDialogVisible = false
    },
    openEventChartDialog () { // 打开时间图谱对话框
      let _this = this
      this.closeAllDialog()
      let color = ['#1D518C',
        '#2A82E4',
        '#74ADED',
        '#3F4D5C']
      appJs.checkVip().then(() => {
        this.eventChartDialogVisible = true
        this.axios.post('/webApi/v3/assist/myNewsChartsData', { 'articleId': _this.articleId }).then((response) => {
          // 渲染词云

          let myChart = echarts.init(document.getElementById('wordsChart'))
          myChart.setOption({

            series: [{
              type: 'wordCloud',
              shape: 'circle',
              left: 'center',
              top: 'center',
              width: '90%',
              height: '90%',
              right: null,
              bottom: null,
              sizeRange: [12, 60],
              rotationRange: [-90, 90],
              rotationStep: 45,
              gridSize: 8,
              drawOutOfBound: false,
              textStyle: {
                normal: {
                  fontFamily: 'sans-serif',
                  fontWeight: 'bold',
                  // Color can be a callback function or a color string
                  color: function () {
                    // Random color
                    return color[Math.floor(Math.random() * color.length)]
                  }
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowColor: '#333'
                }
              },
              data: JSON.parse(response.data.wordcloudDatas)
            }]
          })

          // 渲染词性分类
          try {
            let graphChart = echarts.init(document.getElementById('wordTypeChart'))

            let adjectiveStr = response.data.adjective
            let verbStr = response.data.verb
            let nounStr = response.data.noun
            let data = []
            data.push({ 'name': '文本内容', 'symbolSize': 80, 'draggable': 'true', 'value': 27, label: { normal: { position: 'inside' } } })
            let links = []
            let categories = [{ 'name': '名词' }, { 'name': '动词' }, { 'name': '形容词' }]
            if (nounStr !== '') {
              data.push({ 'name': '名词', 'symbolSize': 40, 'category': '名词', 'draggable': 'true', 'value': 15, label: { normal: { position: 'inside' } } })
              links.push({ 'source': '文本内容', 'target': '名词' })

              let nouns = nounStr.split(',')
              for (let i = 0; i < nouns.length; i++) {
                if (i === 6) { break }
                data.push({ 'name': nouns[i], 'symbolSize': 20, 'category': '名词', 'draggable': 'true', 'value': i })
                links.push({ 'source': '名词', 'target': nouns[i] })
              }
            }
            if (verbStr !== '') {
              data.push({ 'name': '动词', 'symbolSize': 40, 'category': '动词', 'draggable': 'true', 'value': 15, label: { normal: { position: 'inside' } } })
              links.push({ 'source': '文本内容', 'target': '动词' })
              let verbs = verbStr.split(',')
              for (let j = 0; j < verbs.length; j++) {
                if (j === 6) { break }
                data.push({ 'name': verbs[j], 'symbolSize': 20, 'category': '动词', 'draggable': 'true', 'value': 5 })
                links.push({ 'source': '动词', 'target': verbs[j] })
              }
            }
            if (adjectiveStr !== '') {
              data.push({ 'name': '形容词', 'symbolSize': 40, 'category': '形容词', 'draggable': 'true', 'value': 15, label: { normal: { position: 'inside' } } })
              links.push({ 'source': '文本内容', 'target': '形容词' })
              let adjectives = adjectiveStr.split(',')
              for (let k = 0; k < adjectives.length; k++) {
                if (k === 5) { break }
                data.push({ 'name': adjectives[k], 'symbolSize': 20, 'category': '形容词', 'draggable': 'true', 'value': 5 })
                links.push({ 'source': '形容词', 'target': adjectives[k] })
              }
            }
            graphChart.setOption({
              color: color,
              tooltip: { formatter: '{b}' },
              toolbox: {
                show: true,
                feature: {
                  restore: {
                    show: false
                  },
                  saveAsImage: {
                    show: false
                  }
                }
              },
              animationDuration: 3000,
              animationEasingUpdate: 'quinticInOut',
              series: [{
                name: '知识体系',
                type: 'graph',
                layout: 'force',

                force: {
                  repulsion: 300,
                  gravity: 0.2,
                  edgeLength: 20,
                  layoutAnimation: true
                },
                data: data,
                links: links,
                categories: categories,
                focusNodeAdjacency: false,
                roam: false,
                label: {
                  normal: {
                    show: true,
                    position: 'top',
                    formatter: '{b}',
                    fontSize: 14,
                    fontStyle: '600'

                  }
                },
                lineStyle: {
                  normal: {
                    width: 2,
                    color: 'source',
                    curveness: 0,
                    type: 'solid'
                  }
                }
              }]
            })
          } catch (err) {
            console.error(err)
          }

          // 渲染实体识别
          try {
            var addressStr = response.data.addressStr
            var namesStr = response.data.namesStr
            var orgsStr = response.data.orgsStr

            var eData = []
            eData.push({ 'name': '文本内容', 'symbolSize': 80, 'draggable': 'true', 'value': 27, label: { normal: { position: 'inside' } } })
            var eLinks = []
            var eCategories = [{ 'name': '人名' }, { 'name': '地名' }, { 'name': '机构名' }]
            if (addressStr !== '' && addressStr !== undefined) {
              eData.push({ 'name': '地名', 'symbolSize': 40, 'category': '地名', 'draggable': 'true', 'value': 15, label: { normal: { position: 'inside' } } })
              eLinks.push({ 'source': '文本内容', 'target': '地名' })

              var address = addressStr.split(',')
              for (var a = 0; a < address.length; a++) {
                if (a === 6) { break }
                eData.push({ 'name': address[a], 'symbolSize': 20, 'category': '地名', 'draggable': 'true', 'value': 5 })
                eLinks.push({ 'source': '地名', 'target': address[a] })
              }
            }
            if (namesStr !== '' && namesStr !== undefined) {
              eData.push({ 'name': '人名', 'symbolSize': 40, 'category': '人名', 'draggable': 'true', 'value': 15, label: { normal: { position: 'inside' } } })

              var names = namesStr.split(',')
              eLinks.push({ 'source': '文本内容', 'target': '人名' })
              for (var b = 0; b < names.length; b++) {
                if (b === 6) { break }
                eData.push({ 'name': names[b], 'symbolSize': 20, 'category': '人名', 'draggable': 'true', 'value': 5 })
                eLinks.push({ 'source': '人名', 'target': names[b] })
              }
            }
            if (orgsStr !== '' && orgsStr !== undefined) {
              eData.push({ 'name': '机构名', 'symbolSize': 40, 'category': '机构名', 'draggable': 'true', 'value': 15, label: { normal: { position: 'inside' } } })

              eLinks.push({ 'source': '文本内容', 'target': '机构名' })
              var orgs = orgsStr.split(',')
              for (var c = 0; c < orgs.length; c++) {
                if (c === 6) { break }
                eData.push({ 'name': orgs[c], 'symbolSize': 20, 'category': '机构名', 'draggable': 'true', 'value': 5 })
                eLinks.push({ 'source': '机构名', 'target': orgs[c] })
              }
            }

            var entityGraphChart = echarts.init(document.getElementById('entityChart'))

            entityGraphChart.setOption({
              color: color,
              tooltip: { formatter: '{b}' },
              toolbox: {
                show: true,
                feature: {
                  restore: {
                    show: false
                  },
                  saveAsImage: {
                    show: false
                  }
                }
              },
              animationDuration: 3000,
              animationEasingUpdate: 'quinticInOut',
              series: [{
                name: '知识体系',
                type: 'graph',
                layout: 'force',

                force: {
                  repulsion: 300,
                  gravity: 0.2,
                  edgeLength: 20,
                  layoutAnimation: true
                },
                data: eData,
                links: eLinks,
                categories: eCategories,
                focusNodeAdjacency: false,
                roam: false,
                label: {
                  normal: {

                    show: true,
                    position: 'top',
                    formatter: '{b}',
                    fontSize: 14,
                    fontStyle: '600'

                  }
                },
                lineStyle: {
                  normal: {
                    width: 2,
                    color: 'source',
                    curveness: 0,
                    type: 'solid'
                  }
                }
              }]
            })
          } catch (err) {
            console.error(err)
          }

          // 渲染次相关性
          try {
            var chartPanel = echarts.init(document.getElementById('wordsChart_panel'))
            var markLineOpt = {}
            var wordRelationDatas = JSON.parse(response.data.wordRelationDatas)
            var centerPList = []
            centerPList.push([50, 50, wordRelationDatas[0].name, '#8570b0'])
            var bg = {
              name: '相关背景',
              type: 'pie',
              avoidLabelOverlap: false,
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: [{
                value: 1
              }],
              animation: false
            }

            var dot = {
              name: '强相关',
              type: 'scatter',
              xAxisIndex: 0,
              yAxisIndex: 0,
              symbol: 'circle',
              symbolSize: 40,
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    color: '#555'
                  },
                  position: 'bottom',
                  formatter: function (param) {
                    return param.data[2]
                  }
                }
              },
              itemStyle: {
                normal: {
                  color: color[0]
                }
              },

              data: []
            }
            /**
             * x坐标
             * y坐标
             * name 标签名称
             * symbolSize 点大小
             * 趋势，1:上升 0:下降
             */
            var datalist = []
            // dot坐标
            var xyDatas = [['50', '50'], ['25', '75'], ['50', '10'], ['50', '102'], ['85', '30'], ['35', '-8'], ['90', '0'], ['10', '105'], ['96', '100'], ['100', '75'], ['-5', '50']]
            // dot大小
            var dotSizes = [80, 60, 55, 48, 40, 36, 30, 28, 25, 22, 18]
            // 迭代灌入数据
            for (var d = 0; d < wordRelationDatas.length; d++) {
              if (d === 0) {
                continue
              }
              if (d < 5) {
                datalist.push([xyDatas[d][0], xyDatas[d][1], wordRelationDatas[d].name, dotSizes[d], 1])
              } else if (d < 11) {
                datalist.push([xyDatas[d][0], xyDatas[d][1], wordRelationDatas[d].name, dotSizes[d], 0])
              }
            };
            var dataMap = datalist.map((item) => {
              return Object.assign({}, dot, {
                symbolSize: item[3],
                itemStyle: {
                  normal: {
                    color: item[4] === 1 ? color[1] : color[0]
                  }
                },
                data: [
                  item
                ]
              })
            })

            var optionPanel = {
              color: color,
              backgroundColor: '#0000',
              title: {
                text: '',
                x: '35%',
                y: 0
              },
              toolbox: {
                show: true,
                feature: {
                  restore: {
                    show: false
                  },
                  saveAsImage: {
                    show: false
                  }
                }
              },
              tooltip: {
                trigger: 'item',
                backgroundColor: '#fff',
                textStyle: {
                  color: '#999'
                },
                formatter: (item) => {
                  if (item.data[2]) {
                    return item.data[2]
                  }
                }
              },
              xAxis: [{
                gridIndex: 0,
                type: 'value',
                show: false,
                min: 0,
                max: 100,
                nameLocation: 'middle',
                nameGap: 30

              }],
              yAxis: [{
                gridIndex: 0,
                min: 0,
                show: false,
                max: 100,
                nameLocation: 'middle',
                nameGap: 30
              }],
              series: [
                ...dataMap, {
                  name: '弱相关',
                  type: 'scatter',
                  xAxisIndex: 0,
                  yAxisIndex: 0,
                  symbol: 'circle',
                  symbolSize: 120,
                  label: {
                    normal: {
                      show: true,
                      textStyle: {
                        fontSize: '20'
                      },
                      formatter: function (param) {
                        return param.data[2]
                      }
                    }

                  },

                  itemStyle: {
                    normal: {
                      color: color[2]
                    }
                  },
                  data: centerPList,
                  markLine: markLineOpt
                },
                Object.assign({}, bg, {
                  radius: ['0%', '100%'],
                  itemStyle: {
                    normal: {
                      color: '#ddd'
                    },
                    emphasis: {
                      color: '#ddd'
                    }
                  }
                }),
                Object.assign({}, bg, {
                  radius: ['100%', '200%'],
                  itemStyle: {
                    normal: {
                      color: '#eee'
                    },
                    emphasis: {
                      color: '#eee'
                    }
                  }
                })

              ]
            }
            chartPanel.setOption(optionPanel)
          } catch (e) {
            console.error(err)
          }
        })
      })
    },

    toChangeArticle () {
      console.log(localStorage.getItem('hide_rewrite_dialog'))
      this.hiddenRewiterTips = localStorage.getItem('hide_rewrite_dialog') || false
      if (!localStorage.getItem('hide_rewrite_dialog')) {
        this.rewriteDialogVisible = true
      } else {
        this.changeArticle()
      }
    },
    changeArticle () {
      if (this.hiddenRewiterTips) {
        localStorage.setItem('hide_rewrite_dialog', '1')
      } else {
        localStorage.removeItem('hide_rewrite_dialog')
      }
      this.rewriteDialogVisible = false
      let _this = this
      this.axios.get(`/webApi/v3/article/changeArticle?articleId=${_this.articleId}`).then((response) => {
        _this.getArticleInfo(true)
      })
    },
    getArticleInfo (isChange) {
      let _this = this
      _this.articleLoading = true
      this.axios.get(`/webApi/v3/article/detail?articleId=${_this.articleId}`).then((response) => {
        _this.articleInfo = response.data
        _this.articleLoading = false
        if (isChange) {
          _this.$forceUpdate()
          return
        }
        if (response.data && response.data.carId) {
          _this.carForm.carId = response.data.carId
          _this.changeType(0)
        } else if (response.data.articleType === 'fin.stock.freedom') {
          _this.changeType(3)
        } else if (response.data.articleType.indexOf('fin') === 0) {
          _this.changeType(1)
        } else if (response.data.articleType.indexOf('normal.template') > -1) {
          _this.changeType(0)
        } else {
          _this.changeType(2)
        }

        if (_this.articleInfo.articleType && _this.articleInfo.articleType.indexOf('refer') > -1) {
          _this.showRecommend = true
          setTimeout(function () {
            _this.showRecommend = false
          }, 3000)
        }

        _this.$forceUpdate()
        _this.init(true)

        setTimeout(function () {
          _this.bodyLoading = false
        }, 2000)
      })
    },

    closeIntelligenceEditDialog () {
      this.intelligenceEditDialogVisible = false
    },

    handCommand (command) {
      if (command === 'export') {
        this.exportArticle()
      }
      if (command === 'help') {
        window.open('https://mp.weixin.qq.com/s/nQ78KO4IZvAXY4Yayon7rQ', '_blank')
      }
    },
    // 导出文章
    exportArticle () {
      this.axios.get('/webApi/v3/article/exportArticle?id=' + this.articleId).then((response) => {
        let winRes = window.open(response.data, '_blank')
        if (winRes == null || typeof (winRes) === 'undefined') {
          this.$message.error('下载窗口被拦截了，请解除拦截后重新导出！');
          return
        }
        this.$message({
          message: '文章导出成功',
          type: 'success'
        })
      })
    },
    //  保存文章接口
    async saveArticle (isAuto) {
      let _this = this
      let fid = -1
      if (_this.articleInfo.folderId) {
        fid = _this.articleInfo.folderId
      } else {
        fid = this.forderId
      }
      if (!isAuto) {
        this.articleInfo.content = this.articleInfo.content.replace(/sensitive_mark/g, '')
        this.articleInfo.content = this.articleInfo.content.replace(/insertP/g, '')
      }
      this.axios.post('/webApi/v3/article/update', { 'autoDocId': _this.articleInfo.autoDocId, 'title': _this.articleInfo.title, 'content': _this.articleInfo.content, 'folderId': fid, '$noLoading': true }).then((response) => {
        if (!isAuto) {
          _this.$message({
            message: '文章更新成功',
            type: 'success'
          })
        }
        _this.articleInfo.content = _this.articleInfo.content
      })
    },

    // 初始化数据
    init (loadMore) {
      localStorage.setItem('curArticleId', this.articleId)
      if (!loadMore) {
        this.getArticleInfo()
        return
      }
      this.isModel = this.articleInfo.articleType && this.articleInfo.articleType.indexOf('stock') === 0
      if (!this.isModel) {
        this.$forceUpdate()
      }
    },
    // 搜索关键词
    querySearchAsync (key, cb) {
      let result = []
      if (!key) {
        cb(result)
        return
      }
      let tempKey = key.replace(/\s*/g, '')
      if (this.keyMap[tempKey]) {
        cb(this.keyMap[tempKey])
        return
      }

      let _this = this
      this.axios.post('/webApi/v3/hot/hot-tips-list?size=5&keyword=' + key, { '$noLoading': true }).then((response) => {
        response.data.forEach(e => {
          result.push({ 'value': e.heightLightWordsStr, 'title': e.h_title || e.title, 'extValue': e.keywords, 'newsIds': e.newsIds })
        })
        cb(result)
        _this.keyMap[tempKey] = result
      })
    },
    // 文章导入
    genArticle () {
      let _this = this
      Loading.startLoading('弈写正在努力写作中，请稍等...')
      this.axios.post('/webApi/v3/robot/uploadContent', { 'title': _this.articleInfo.title, 'content': _this.articleInfo.content }).then((response) => {
        if (response.data.autoNewsId) {
          _this.$router.replace({ path: '/newsEdit', query: { articleId: response.data.autoNewsId, 'fid': _this.forderId } })
          _this.articleId = response.data.autoNewsId
          _this.keyword = ''
        } else {
          _this.$message.error('未写作成功，请编辑内容后重试');
        }
      })
    },
    // 命题写作
    genArticleByKeyWord (newsIds) {
      if (!this.keyword) {
        this.$message.error('请输入关键词后，重新写作')
        return
      }
      if (this.articleId) {
        this.$confirm('是否重新写作一篇？请确认现在的文章已经保存', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.genArticleByKeyWord2(newsIds)
        }).catch(() => {

        })
      } else {
        this.genArticleByKeyWord2(newsIds)
      }
    },
    genArticleByKeyWord2 (newsIds) {
      Loading.startLoading('弈写正在努力写作中，请稍等...')
      let _this = this
      this.axios.post('/webApi/v3/robot/writing-by-keyword', { 'sentence': _this.keyword, 'folderId': this.forderId, 'belongIds': newsIds }).then((response) => {
        if (response.data.autoNewsId) {
          _this.$router.replace({ path: '/newsEdit', query: { articleId: response.data.autoNewsId, 'fid': _this.forderId } })
          _this.articleId = response.data.autoNewsId
          _this.keyword = ''
        } else {
          _this.$message.error('写作失败，请换个词试试');
        }
      })
    },

    // 选择关键词
    handleSelect (val) {
      this.keyword = val.extValue
      this.genArticleByKeyWord(val.newsIds)
    },

    // 把摘要插入段落
    insertDescToArticle (desc) {
      if (this.activeName === '文案库' && this.carForm.tag === 'SUBTITLE') {
        this.insertHtml('<h4>' + desc + '</h4>')
      } else {
        this.insertHtml('<p>' + desc + '</p>')
      }
    },

    insertHtml (temp) {
      tinyMCE.execCommand('mceInsertContent', false, temp);
    },

    //  拖拽完成
    dragEnd (val) {
      // let temp = '<p>' + val + '</p>\n'
      tinyMCE.execCommand('mceInsertContent', false, val);
    },

    checkSensitiveWord () {
      let _this = this
      this.articleInfo.content = this.articleInfo.content.replace(/sensitive_mark/g, '')
      let temp = tinymce.activeEditor.getContent({ 'format': 'text' })
      this.axios.post('/webApi/v3/assist/sensitiveWord', { 'sentence': temp }).then(resp => {
        _this.sensitiveWordRes = resp.data
        resp.data.totalWordList.forEach(f => {
          // eslint-disable-next-line no-eval
          let re = eval('/' + f + '/g');
          _this.articleInfo.content = _this.articleInfo.content.replace(re, '<font  class="sensitive_mark">' + f + '</font>')
        })
        _this.editVisble = false
        _this.editVisble = true
      })
    },
    checkCorrectWord () {
      let _this = this
      this.articleInfo.content = this.articleInfo.content.replace(/sensitive_mark/g, '')
      let temp = tinymce.activeEditor.getContent({ 'format': 'text' })
      this.axios.post('/webApi/v3/assist/wordsCorrection', { 'content': temp }).then(resp => {
        _this.correctWordRes = resp.data
        resp.data.forEach(f => {
          // eslint-disable-next-line no-eval
          let re = eval('/' + f.error + '/g');
          _this.articleInfo.content = _this.articleInfo.content.replace(re, '<font  class="sensitive_mark">' + f.error + '</font>')
        })
      })
    },

    /**
   * 子组件用的
   * @param {} val
   */
    modifyArticleContent (val) {
      this.articleInfo.content = val
    },
    /**
   * 子组件用的
   * @param {} val
   */
    modifyArticleContentArray (val) {
      this.articleContentArray = val
      this.updateArtticleContent()
    },
    chooseLikeWord () { // 选择近义词,展现所有
      console.log(this.likeWordKeyWord)
      tinymce.activeEditor.plugins.searchreplace.find(this.likeWordKeyWord, false, false, true)
    },
    toReplaceLikeWord (newWord) {
      tinymce.activeEditor.plugins.searchreplace.replace(newWord, true, true)
      delete this.likeWordMap[this.likeWordKeyWord]
      this.$forceUpdate()
      this.updateLikeWord()
    },
    markSourceWord () {
      console.log(this.sourceKeyword)
      if (!this.sourceKeyword) {
        return
      }
      tinymce.activeEditor.plugins.searchreplace.find(this.sourceKeyword, false, false, false)
    },
    replaceAllLikeWord () {
      tinymce.activeEditor.plugins.searchreplace.replace(this.targetKeyword, true, true)
    },
    onEditorMouseUp (content) {
      console.log('松开鼠标', content)

      this.searchContent = content
    },
    resetEditHeight () {
      let iframe = document.getElementById('articleContent_ifr')
      if (iframe) {
        let iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
        if (iframeWin.document.body) {
          document.getElementsByClassName('tox-tinymce')[0].style.height = ((iframeWin.document.body.clientHeight) + 250) + 'px';
        }
      }
    },
    toReport (myDocId, sourceNewsId, title) {
      console.log(`举报，myDocId:${myDocId},sourceNewsId:${sourceNewsId},title:${title}`)
      this.reportDialogVisible = true
      this.reportInfo.myDocId = myDocId
      this.reportInfo.sourceNewsId = sourceNewsId
      this.reportInfo.title = title
      this.reportInfo.tipOff = ''
    },
    doReport () {
      this.axios.post('/webApi/v3/tipOff/doReport', this.reportInfo).then(resp => {
        this.reportDialogVisible = false
        this.$message({
          message: '举报成功',
          type: 'success'
        })
        if (this.reportInfo && this.reportInfo.myDocId) {
          this.$router.back()
        }
        if (this.reportInfo && this.reportInfo.sourceNewsId) {
          this.articleTabkKey++;
        }
      })
    }
  },
  components: {
    leftMenu,
    LikeWord,
    draggable,
    'Editor': Editor,
    vEditDiv,
    modelTab,
    articleTab,
    imageTab,
    knowlegeTab,
    materialTab,
    carTab
  },
  watch: {
    searchContent: function () {
      if (this.intelligenceEditDialogVisible) {
        this.seachLikeWord()
      }
    },

    articleId: function () {
      if (this.articleId) {
        this.init(false)
        let _this = this
        this.axios.post('/webApi/v3/article/news-right-info?' + Math.random(), { 'autoDocId': this.articleId }).then(resp => {
          if ((resp.data.myNewsIsBuy === 'YES' && resp.data.myNewsHaveVipTime > 0) || resp.data.userVipLevel === 'GOLD') { // 已经购买 未过期
            _this.hasRight = true
          }
        })
      } else {
        this.bodyLoading = false
      }
    },

    articleInfo: {
      handler () {
        this.saveArticle(true)
        this.resetEditHeight()
      },
      deep: true
    }

  },
  filters: {
    numFilter (value) {
      let realVal = parseFloat(value).toFixed(2)
      return realVal + '%'
    }
  },
  computed: {

  },
  mounted () {
    window.onEditorMouseUp = this.onEditorMouseUp
    this.from = this.$route.query.from || 'articles'

    this.forderId = this.$route.query.fid
    this.articleId = this.$route.query.articleId
    if (!this.articleId) {
      this.hasRight = true
    }
    let _this = this
    appJs.getVip().then(data => {
      _this.vipInfo = data
    })
    this.axios.get('/webApi/v3/tipOff/list').then(resp => {
      _this.reportTypes = resp.data
    })
  }
}
</script>
<style lang="less">
@import '../assets/css/index.less';

.tox .tox-tbtn--select {
  width: 70px !important;
}

.report_type {
  padding: 0px;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 15px;
}

.tox-tinymce-inline {}

.main_workspace {
  display: flex;

  .changeType {
    display: none;
  }

  .isActive {
    height: calc(100vh - 106px);
    display: block;
    border-radius: 8px;
    background: #ffffff;
    padding: 0px;
    position: relative;
    box-sizing: border-box;
  }

  .innerDialog {
    width: 100%;
    height: calc(100vh - 110px);
    top: 0;
    background-color: white;
    overflow-y: auto;
    padding: 10px;
    border-radius: 5px;
    box-sizing: border-box;
    position: absolute;
    z-index: 9990;
  }
}

.moreBtn {
  background-image: url('../assets/imgs/more.png');
  width: 24px;
  height: 24px;
  display: inline-block;
  background-size: 100% auto;
  vertical-align: middle;
  background-repeat: no-repeat;
}

.saveBtn {
  left: 710px;
  top: 0px;
  width: 80px;
  height: 40px;
  opacity: 1;
  border-radius: 6px;
  background: linear-gradient(90deg,
      rgba(59, 136, 234, 1) 0%,
      rgba(60, 147, 240, 0.93) 30.26%,
      rgba(60, 169, 251, 1) 62.72%,
      rgba(60, 144, 238, 1) 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 10px 8px 10px;
  color: white !important;

  .saveIcon {
    background-image: url('../assets/imgs/saveIcon.png');
    width: 20px;
    height: 20px;
    display: inline-block;
    background-size: 100%;
    vertical-align: middle;
  }
}

.rewriterBtn {
  position: fixed;
  right: 50px;
  bottom: 50px;
}

.my_edit_container {
  width: calc(100vw - 400px);
  min-width: 880px;
  height: calc(100vh - 100px);
  position: relative;
  overflow: auto;
  text-align: left;
  margin: auto;

  .innerContainer {
    max-width: 1000px;
    min-width: 700px;
    position: relative;
    overflow-y: auto;
    width: 90%;
    margin: auto;
    background-color: white;
    // box-shadow: 0px 3px 16px 4px #bbbbbb55;
    border-radius: 10px;
  }

  .recommend {
    position: fixed;
    z-index: 99;
    width: 330px;
    top: 70px;
  }

  .editorToolbarBackground {
    position: fixed;
    background: @backgroud-color-editor;
    width: 100%;
    height: 50px;
    z-index: 2;
  }

  .ck-button,
  .ck-dropdown {
    margin-right: 15px;
  }

  .el-dialog {
    background: @backgroud-color-whiter !important;
  }

  .titlePositon {
    height: 0px;
    top: 70px;
    position: absolute;
    left: 0;
    width: 100%;
  }

  .titleContainer {
    box-sizing: border-box;
    padding: 10px 20px;
    width: 80%;
    min-width: @eidt-content-min-width;
    max-width: @eidt-content-max-width;
    margin: auto;
    position: relative;
    background-color: white;
    border-bottom: 1px solid #999;
    border: 0;
    height: auto;
    z-index: 1;
  }

  .myWordCount {
    //CKMARK
    min-width: @eidt-content-min-width;
    max-width: @eidt-content-max-width;
    position: relative;
    overflow: auto;
    background-color: @backgroud-color-editor;
    text-align: left;
    width: 100%;
    text-align: center;
    top: -50px;
    background-color: #0000;
    color: #666;
    font-size: 0.8em;
    margin: auto;
  }

  .boolbarCover {
    position: sticky;
    width: 100%;
    height: 50px;
    top: 0px;
    z-index: 5;
    background-color: #f7f7fa !important;
  }

  .toolbar {
    height: 125px;
  }

  .ck-focused {
    box-shadow: 0 !important;
    border: 0 !important;
  }

  #toolbar {
    position: relative;
    top: 0px;
    z-index: 999;
    width: 100% !important;
    margin: auto;

    .saveBtnContainer {
      width: 180px;
      margin: inherit;
      position: fixed;
      right: 0;
      text-align: left;
      right: 35px;

      .save_btn {
        height: 31px;
        padding: 5px 10px;
        background-color: #2e8eff;
        color: white;
      }
    }
  }

  .ck-reset_all {
    position: sticky !important;
    top: 0px;
    z-index: 998;
    height: 50px !important;
    border: 0px !important;
    background-color: @backgroud-color-editor !important;
    max-width: @eidt-content-max-width;
    min-width: @eidt-content-min-width;
    margin: auto !important;
    padding: 0 !important;
    width: 80% !important;
    box-shadow: 0px 0px 0px 3px #f6f6f6 !important;
  }

  .ck-editor__editable {
    box-shadow: 1px 1px 19px 0px #eee !important;
  }

  .ck-content {
    box-sizing: border-box;
    padding: 10px 30px;
    width: 80%;
    min-width: @eidt-content-min-width;
    max-width: @eidt-content-max-width;
    margin: auto;
    min-height: calc(100vh - 250px);
    height: auto;
    background-color: white;
    position: relative;
    top: 10px;
    border-radius: 5px !important;
    border: 0 !important;
    box-shadow: 1px 1px 12px 0px #666;
    margin-bottom: 30px;
    line-height: 33px;
    padding-bottom: 30px;
  }
}

.editContainer {
  background-color: #fff;
  height: calc(100vh - 170px);
  top: 50px;
  position: relative;
  overflow-y: auto;

  .tox-editor-header {
    position: fixed;
    top: 85px !important;
    border-bottom: none !important;
    min-width: 600px !important;
    box-shadow: none !important;
    padding: 0px 20px;
  }

  .tox-sidebar-wrap {
    padding: 20px;
    padding-top: 0px;
  }

  .tox-tinymce {
    // height: calc(100vh - 130px) !important;
    border: 0px;

    .tox-statusbar__text-container {
      display: none !important;
    }
  }

  .articleTitleContainer {
    margin-left: 20px;
    margin-top: 45px;

    .articleTitle {
      width: calc(100% - 100px);
      border: none !important;
      font-weight: 700;
      font-size: 22px;
      color: #080808;
      padding-left: 20px;
      // padding-bottom: 0px;
      // margin-top: 30px;
      background-color: white;
      vertical-align: top;
      display: inline-block;
      outline: none;
      resize: none;
    }
  }

  .isRefer::before {
    content: ' ';
    display: inline-block;
    background-size: 100%;
    vertical-align: top;
    background-repeat: no-repeat;
    width: 47px;
    height: 30px;
    background-image: url('../assets/imgs/refer.png');
  }

  .isUpload::before {
    content: ' ';
    display: inline-block;
    background-size: 100%;
    vertical-align: top;
    background-repeat: no-repeat;
    width: 47px;
    height: 30px;
    background-image: url('../assets/imgs/import.png');
  }

  .isAi::before {
    content: ' ';
    display: inline-block;
    background-size: 100%;
    vertical-align: top;
    background-repeat: no-repeat;
    width: 47px;
    height: 30px;
    background-image: url('../assets/imgs/ai.png');
  }

  .articleContent {
    padding: 20px;

    p {
      font-size: 16px;
      color: #2c3e50;
      line-height: 30px;
      margin: 10px 0px !important;
    }
  }
}

.nav_header {
  width: 100%;
  padding: 0px;
  z-index: 999;
  // box-shadow: 0px 0px 20px @border-color-gray;
  position: sticky;
  top: 0px;
  left: 0px;
  background-color: white;
  text-align: left;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;

  .changeType {
    border-radius: 10px !important;
    background-color: #f6f6f8;
    color: #8b8ba7;
    box-shadow: none;
    border: none;
  }

  .isActive {
    border-radius: 10px !important;
    background: linear-gradient(90deg,
        #3b88ea 0%,
        #3c93f0 30.26%,
        #3ca9fb 62.72%,
        #3c90ee 100%);
    color: white;

    box-shadow: none;
    border: none;
  }

  .right_menu {
    margin-right: 25px;
  }

  .right_menu .el-link {
    font-size: 22px;
  }
}

.noBorder {
  .el-table__cell {
    border-bottom: none !important;
  }
}

.tableHead {
  color: rgba(60, 66, 88, 1);
}

.rewriteDialog {
  border-radius: 10px;

  .el-dialog__body {
    padding: 20px !important;
    padding-bottom: 0px !important;
  }

  .el-dialog__header {
    padding: 10px !important;
  }
}
</style>
<style lang="less" scoped>
@import '../assets/css/index.less';

.reportDialog {

  .isRefer::before {
    content: ' ';
    display: inline-block;
    background-size: 100%;
    vertical-align: top;
    background-repeat: no-repeat;
    margin-top: 4px;
    width: 31px;
    height: 20px;
    background-image: url('../assets/imgs/refer.png');
  }

  .isUpload::before {
    content: ' ';
    display: inline-block;
    background-size: 100%;
    vertical-align: top;
    background-repeat: no-repeat;
    width: 47px;
    height: 30px;
    background-image: url('../assets/imgs/import.png');
  }

  .isAi::before {
    content: ' ';
    display: inline-block;
    background-size: 100%;
    vertical-align: top;
    background-repeat: no-repeat;
    width: 31px;
    height: 20px;
    margin-top: 4px;
    background-image: url('../assets/imgs/ai.png');
  }
}

.active_small {
  width: 200px;
  height: 40px;
  background-image: url('../assets/imgs/active_small.png');
  background-size: contain;
  background-repeat: no-repeat;
}

.backBtn {
  width: 24px;
  height: 24px;
  background-image: url('../assets/imgs/Cheveron.png');
  display: inline-block;
  background-size: 100%;
}

ul {
  -ms-overflow-style: none;
  /*火狐下隐藏滚动条*/
  overflow: -moz-scrollbars-none;
}

.sortable-chosen {
  color: #d81e06 !important;
}

.deleteAble {
  // width: calc(100% - 30px);
  width: 100%;
}

p[contenteditable] {
  padding-left: 0px;
}

// p[contenteditable]::before {
//   content: "\e6a8";
//   font-family: "iconfont" !important;
//   font-size: 24px;
//   position: absolute;
//   width: 25px;
//   left: 0px;
//   pointer-events: none;
// }
p[contenteditable]:focus {
  color: #d81e06 !important;
}

p[contenteditable]:focus:before {
  content: '\e635';
  font-family: 'iconfont' !important;
  font-size: 16px;
  position: absolute;
  width: 25px;
  left: 0px;
  pointer-events: none;
}

.eventCard {
  width: 96%;
  height: 300px;
  box-shadow: 2px 8px 10px rgba(184, 184, 210, 0.2);
  margin-bottom: 10px;
  border-radius: 8;
  overflow: hidden;

  .chartContainer {
    width: 100%;
    height: 300px;
  }
}

.left_bottom_close_container {
  width: 100%;
  position: absolute;
  bottom: 4px;
  text-align: right;
}

.main_menu_openIcon {
  position: absolute;
  bottom: 10px;
  left: 12px;
  text-align: center;
  width: 56px;
}

.xy_container {
  color: #666;
}

.rightDrager {
  height: calc(100vh - 50px);
  width: 400px;
  position: fixed;
  top: 50px;
  z-index: 10000;
  background: @backgroud-color-whiter;
  border-radius: 5px;
  right: 0;
  padding: 25px;
  box-shadow: 1px 1px 15px #666;
}

.keyword_container .el-radio--mini.is-bordered {
  padding: 5px 5px 0 5px;
  border-radius: 3px;
  height: 26px;
  margin-right: 5px;
  margin-left: 3px !important;
  background: #f0f5ff;
}

.workContainer {
  height: calc(100vh - 50px);
  overflow: hidden;
}

.w-e-text-container {
  height: 90% !important;
  /*!important是重点，因为原div是行内样式设置的高度300px*/
}

.leftContainer .el-dialog__wrapper {
  position: absolute !important;
  height: 100%;
}

.w-e-toolbar {
  user-select: none;
}

.w-e-panel-tab-content {
  user-select: none;
}

.left_conatainer_switcher {
  border: solid 1px #ccc;
  height: 35px;
  width: 100%;
}

.left_conatainer_switcher_txt {
  text-align: left;
  float: left;
  width: 50%;
  padding-left: 20px;
}

.left_conatainer_switcher_btn {
  text-align: right;
  float: right;
  width: 30%;
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/app/newsEdit.vue